module.exports = __webpack_public_path__ + "static/media/plus-square.bc18b04e.svg";